import React, {Component} from "react";
import PropTypes from "prop-types";
import "./PopUp.css";

/**

 * PopUp

 * @augments {Component<Props, State>}

 */
export default class PopUp extends Component {
  constructor(props) {
    super(props);
    this.handleClose = this.handleClose.bind(this)
  }

  handleClose = () => {
    const showPopUp = false;
    this.props.closePopUp(showPopUp, this.props.previousValue);
  }

  handleChange = () => {
    const showPopUp = false;
    this.props.changePopUp(showPopUp, this.props.currentValue);
  }

  render() {
    const props = this.props;
    return (
      props.showPopUp ?
        <div id="myModal" className="modal">
          <div className="modal-content">
            <span onClick={this.handleClose} className="close">&times;</span>
            <h2>Achtung!</h2>
            <h3>Möchten Sie wirklich die Einrichtungsart ändern?</h3>
            <div className="modal-button">
              <button onClick={this.handleChange} className="button-accept" style={{verticalAlign: 'middle'}}><span>Änderung bestätigen</span>
              </button>
              <button onClick={this.handleClose} className="button-cancel" style={{verticalAlign: 'middle'}}>
                <span>Abbrechen</span></button>
            </div>
          </div>
        </div> : null
    )
  }
}
// props for Component from Survey Component
PopUp.propTypes = {
  /** show popup true or false
   *Default: false */
  showPopUp: PropTypes.bool,
  /** previous Value in Dropdown */
  previousValue: PropTypes.number,
  /** current Value in Dropdown */
  currentValue: PropTypes.number,
  closePopUp: PropTypes.func,
  changePopUp: PropTypes.func
};

PopUp.defaultProps = {
  showPopUp: false
};





